<span *ngIf="errorMessage != null">
  <small class="form-text text-danger">
    {{ errorMessage }}
  </small>
</span>